export const USER_ATTRIBUTES = {
  nosync: {
    id: 'nosync',
    label: {
      long: 'label.BROKEN_SYNCS',
      short: 'label.BROKEN_SYNCS'
    }
  },
  unlocked: {
    id: 'unlocked',
    label: {
      long: 'label.UNLOCKED_FIELDS',
      short: 'label.UNLOCKED_FIELDS'
    }
  },
  addin: {
    id: 'addin',
    label: {
      long: 'Add-In Users',
      short: 'Add-In Users'
    }
  },
  bizcard: {
    id: 'bizcard',
    label: {
      long: 'label.BIZCARD_USERS',
      short: 'label.BIZCARD_USERS'
    }
  },
  inactive: {
    id: 'inactive',
    label: {
      long: 'label.DISABLED_USERS',
      short: 'label.DISABLED_USERS'
    }
  }
};
